import { useWatch } from 'react-hook-form';
import { StaticInput, type StaticInputProps } from './StaticInput.tsx';

interface IStaticFormInputProps extends Omit<StaticInputProps, 'value'> {
  name: string;
}

/**
 * Input statico non modificabile con valore definito dal form
 */
export function StaticFormInput(props: IStaticFormInputProps) {
  const { name, ...otherProps } = props;

  const value = useWatch({ name });

  return <StaticInput {...otherProps} value={value} />;
}
